import React, { useState } from 'react';
import { Box, Button } from '@kistech/kis-ui';
import { CheckCircle, Error } from '@mui/icons-material';
import { useStyles } from '../styled';

interface PopupProps {
  message: string;
  resetMessage: () => void;
}

const Popup = (props: PopupProps) => {
  const { message, resetMessage } = props;

  const [isOpen, setIsOpen] = useState(true);

  const classes = useStyles()();

  const handleClose = () => {
    resetMessage();
    setIsOpen(false);
  };

  // If the popup is closed, don't render anything
  if (!isOpen) return null;

  return (
    <Box margin="0 3" width={325}>
      <div className={classes.popupOverlay} onClick={handleClose}>
        <div className={classes.popup}>
          <div className={classes.popupContent}>
            {message === 'Error processing file' ? (
              <Error style={{ fontSize: '4.1875rem', color: 'red', marginBottom: '10px' }} />
            ) : (
              <CheckCircle style={{ fontSize: '4.1875rem', color: '#f26d2e', marginBottom: '10px' }} />
            )}
            <div className={classes.message}>{message}</div>
            <Button style={{ width: '200px' }} onClick={handleClose}>
              <div style={{ alignItems: 'center', fontSize: '20px' }}>Close</div>
            </Button>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default Popup;
